import React, { createContext, useContext, useState } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { Box, CssBaseline } from "@mui/material";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Analytics from "./pages/Analytics";
import Users from "./pages/Users";
import Bots from "./pages/Bots";
import Conversations from "./pages/Conversations";
import Plans from "./pages/Plans";
import UserDetail from "./pages/UserDetail";
import WhatsApp from "./pages/WhatsApp";
import WhatsAppClientDashboard from "./pages/WhatsAppClientDashboard";
import WebsiteOverview from "./pages/WebsiteOverview";
import WebsiteConversations from "./pages/WebsiteConversations";
import WhatsAppConversations from "./pages/WhatsAppConversations";
import WhatsAppSuspended from "./pages/WhatsAppSuspended";
import InstagramOverview from "./pages/InstagramOverview";
import InstagramConversations from "./pages/InstagramConversations";
import Settings from "./pages/Settings";
import AIPage from "./pages/AIPage";
import Earnings from "./pages/Earnings";
import Sidebar from "./components/Sidebar";
import "./App.css";

const theme = createTheme({
  typography: { fontFamily: "'Plus Jakarta Sans', sans-serif" },
  palette: { primary: { main: "#6366f1" } },
  shape: { borderRadius: 8 },
  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          boxShadow: "0 1px 3px rgba(0,0,0,0.04), 0 1px 2px rgba(0,0,0,0.06)",
          transition: "all 0.2s ease",
        },
      },
    },
  },
});

export const SidebarContext = createContext();
export const useSidebar = () => useContext(SidebarContext);

const PrivateRoute = ({ children }) => {
  const token = localStorage.getItem("admin_token");
  return token ? children : <Navigate to="/login" replace />;
};

const Layout = ({ children }) => {
  const [collapsed, setCollapsed] = useState(false);
  return (
    <SidebarContext.Provider value={{ collapsed, setCollapsed }}>
      <Box sx={{ display: "flex", minHeight: "100vh", bgcolor: "#f8faff" }}>
        <Sidebar />
        <Box sx={{ flex: 1, p: 5, overflow: "auto", ml: collapsed ? "72px" : "260px", transition: "margin-left 0.25s ease" }}>
          {children}
        </Box>
      </Box>
    </SidebarContext.Provider>
  );
};

const App = () => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/dashboard" element={<PrivateRoute><Layout><Dashboard /></Layout></PrivateRoute>} />
        <Route path="/analytics" element={<PrivateRoute><Layout><Analytics /></Layout></PrivateRoute>} />
        <Route path="/users" element={<PrivateRoute><Layout><Users /></Layout></PrivateRoute>} />
        <Route path="/users/:id" element={<PrivateRoute><Layout><UserDetail /></Layout></PrivateRoute>} />
        <Route path="/bots" element={<PrivateRoute><Layout><Bots /></Layout></PrivateRoute>} />
        <Route path="/conversations" element={<PrivateRoute><Layout><Conversations /></Layout></PrivateRoute>} />
        <Route path="/plans" element={<PrivateRoute><Layout><Plans /></Layout></PrivateRoute>} />
        <Route path="/whatsapp" element={<PrivateRoute><Layout><WhatsApp /></Layout></PrivateRoute>} />
        <Route path="/whatsapp/client/:clientId" element={<PrivateRoute><Layout><WhatsAppClientDashboard /></Layout></PrivateRoute>} />
        <Route path="/website" element={<PrivateRoute><Layout><WebsiteOverview /></Layout></PrivateRoute>} />
        <Route path="/website/conversations" element={<PrivateRoute><Layout><WebsiteConversations /></Layout></PrivateRoute>} />
        <Route path="/whatsapp/conversations" element={<PrivateRoute><Layout><WhatsAppConversations /></Layout></PrivateRoute>} />
        <Route path="/whatsapp/suspended" element={<PrivateRoute><Layout><WhatsAppSuspended /></Layout></PrivateRoute>} />
        <Route path="/instagram" element={<PrivateRoute><Layout><InstagramOverview /></Layout></PrivateRoute>} />
        <Route path="/instagram/conversations" element={<PrivateRoute><Layout><InstagramConversations /></Layout></PrivateRoute>} />
        <Route path="/ai" element={<PrivateRoute><Layout><AIPage /></Layout></PrivateRoute>} />
        <Route path="/admin/ai" element={<PrivateRoute><Layout><AIPage /></Layout></PrivateRoute>} />
        <Route path="/settings" element={<PrivateRoute><Layout><Settings /></Layout></PrivateRoute>} />
        <Route path="/earnings" element={<PrivateRoute><Layout><Earnings /></Layout></PrivateRoute>} />
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </ThemeProvider>
  );
};

export default App;
